<script context="module">
    import newUniqueId from 'locally-unique-id-generator'
</script>


<script lang="ts">
    import {createForm} from "felte";
    import {myStore} from "../../stores.js";
    import {Utils} from "../../util";
    import {ASSET_URL} from "../../config";
    import {getValue} from "felte"
    import {get} from "svelte/store";
    import ErrorBox from "./ErrorBox.svelte";


    let files = [];
    export let fieldName;
    export let maxFiles = 2;

    export let disabled = false;

    export let maxFileSize = 20; //in MB

    export let errorClass;

    let id = newUniqueId();

    const setFields = $myStore.setFields;
    const setData = $myStore.setData;

    $: if (files) {

        console.log("file changes:",files);
        // Note that `files` is of type `FileList`, not an Array:
        // https://developer.mozilla.org/en-US/docs/Web/API/FileList

        //working alternative:
        // setFields('applicationFiles',files);
        setData(fieldName, files);
    }

    function handleFileSelect(event) {
        const selectedFiles = Array.from(event.target.files);

        const newFiles = selectedFiles.filter(
            file => !files.some(f => f.name === file.name && f.size === file.size)
        );
        // Combine with already selected files, but don't exceed the maximum limit
        files = files.concat(newFiles).slice(0, maxFiles);

        // Clear the input to allow for new selections
        event.target.value = null;


    }

    function handleFileRemove(index){
        console.log("delete for index = ",index);
        files.splice(index, 1);
        files = [...files]; //change detection needed

    }
</script>

<span class="file-btn-wrapper">
<div class="file-btn">
    <label for="{id}" class:error={errorClass}>Télécharger PDF</label>
<input id="{id}" multiple type="file"   on:change={handleFileSelect} disabled={files.length === 2 || disabled} accept="application/pdf" /><!-- bind:files name="applicationFiles"-->
</div>

    <div>
        maximum 2 fichiers (.pdf)
    </div>


</span>
<div class="file-info">
    {#if files.length > 0 }
        {#each files as file, index}
            <div>{file.name} ({Utils.formatFileSize(file.size)})
                <span class="remove-btn" on:click={() => handleFileRemove(index)}>
                    <img src="{ASSET_URL}/assets/img/icons/close-white.svg" />
                </span>
            </div>
        {/each}
    {/if}

</div>
{#if errorClass && errorClass.includes('FileSizeToBig')}
    <ErrorBox>
        Ce fichier dépasse la limite de {maxFileSize} MB (Mo) et ne peut donc pas être téléchargé. Veuillez réduire la taille de votre fichier et le télécharger à nouveau.
    </ErrorBox>

{/if}


<style lang="scss">

  .file-info{

    margin-top:0.75rem;

    div{
      margin-top:5px;
      margin-bottom:5px;

    }

    .remove-btn{
      img{
        width:10px;
        height:10px;
      }
    }

  }

  .file-btn-wrapper {
    display: flex;
    align-items: center;
  }

  .file-btn {
    margin-right: 1rem;
    display: inline-flex;
    align-content: center;


    //height:60px;


    input[type="file"] {
      opacity: 0;
      position: fixed;
      width: 0;
    }


    label {
      display: flex;
      align-items: center;
      line-height: normal;
      cursor:pointer;
      color: $primary-color;
      background-color: #ddd;
      padding: 5px 15px;
      //font-family: sans-serif, Arial;
      font-size: 16px;
      border: 2px solid transparent;
      border-radius: 7px;
      transition: all .2s ease-in-out;


      &.error{
        border-color:$error-color;
      }

      &:hover{
        transform: scale(1.02);
      }
    }


  }


  /*
      $start-item-offset: 6px;
      label {
          border: 1px solid black;
          border-radius: 12px !important;

          display: flex;
          cursor: pointer;
          margin-left: $start-item-offset;

          &.checked {
              border-width: 2px;
              .start-item {
                  border-width: 2px;
                  background: rgba(248, 185, 44, 1);
              }
          }

          &:focus-within {
              box-shadow: var(--btn-focus-box-shadow);
          }
      }
      input[type="radio"] {
          all: unset;
      }
      .start-item {
          border: 1px solid black;
          border-radius: 5px;
          color: black;

          font-family: 'Open Sans', sans-serif;
          font-size: 12px;
          font-weight: 600;
          //line-height: 12px;
          letter-spacing: 0;
          text-align: left;

          line-height: 1;
          margin: auto 0;
          padding: 8px;
          background-color: white;
          transform: translateX(-$start-item-offset);
      }
      .label-text {
          font-family: 'Open Sans', sans-serif;
          font-size: 1rem;
          font-weight: 400;
          line-height: 1.2rem;
          letter-spacing: 0;
          text-align: left;

          color: black;
          padding: 15px 20px 15px 5px;
      }

   */
</style>
